var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Cells',{attrs:{"gameOver":_vm.gameOver,"turn":_vm.turn,"cells":_vm.cells}}),_c('Footer',{attrs:{"gameOver":_vm.gameOver}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }